import React, { useEffect } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CountUp from 'react-countup';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Home = () => {
    // Initialize AOS - FIXED: Added missing initialization
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: false,
            offset: 100,
            easing: 'ease-out-cubic',
            delay: 100,
            startEvent: 'DOMContentLoaded',
        });
        
        // Refresh AOS when window loads
        window.addEventListener('load', AOS.refresh);
        
        return () => {
            window.removeEventListener('load', AOS.refresh);
        };
    }, []);

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2800,
        pauseOnHover: false,
        fade: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    dots: true
                }
            }
        ]
    };

    return (
        <>
            {/* Hero Slider */}
            <div className="container-fluid p-0 position-relative mt-0">
                <Slider {...sliderSettings} className="hero-slider mb-0">
                    <div className="hero-slide">
                        <div className="position-relative">
                            {/* FIX: Added height for images to maintain aspect ratio */}
                            <img
                                className="img-fluid w-100 hero-image"
                                src="img/carousel-01.jpg"
                                alt="A2Z Solutions Services"
                                style={{ 
                                    height: "calc(100vh - 80px)",
                                    minHeight: "400px",
                                    maxHeight: "800px",
                                    objectFit: "cover"
                                }}
                            />
                            <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center"
                                style={{ background: "rgba(6, 3, 21, .7)" }}>
                                <div className="container">
                                    <div className="row justify-content-center justify-content-lg-start">
                                        <div className="col-12 col-lg-8 col-md-10">
                                            <h1 className="display-5 display-lg-3 text-white mb-3 text-center text-lg-start"><strong>
                                                A2Z Solutions</strong>
                                            </h1>
                                            <p className="fs-6 fs-md-5 fw-medium text-white mb-3 mb-md-4 text-center text-lg-start">
                                                Your One-Stop Partner for Growth..<br />
                                                Powering Accuracy, People & Performance.
                                            </p>
                                            <div className="text-center text-lg-start">
                                                <a href="/service" className="btn btn-primary btn-lg py-2 py-md-3 px-4 px-md-5"
                                                   data-aos="zoom-in"
                                                   data-aos-delay="500">
                                                    Read More
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="hero-slide">
                        <div className="position-relative">
                            <img
                                className="img-fluid w-100 hero-image"
                                src="img/carousel-06.webp"
                                alt="A2Z Solutions Services"
                                style={{ 
                                    height: "calc(100vh - 80px)",
                                    minHeight: "400px",
                                    maxHeight: "800px",
                                    objectFit: "cover"
                                }}
                            />
                            <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center"
                                style={{ background: "rgba(6, 3, 21, .7)" }}>
                                <div className="container">
                                    <div className="row justify-content-center justify-content-lg-start">
                                        <div className="col-12 col-lg-8 col-md-10">
                                            <h1 className="display-5 display-lg-3 text-white mb-3 text-center text-lg-start"><strong>
                                                A2Z Solutions</strong>
                                            </h1>
                                            <p className="fs-6 fs-md-5 fw-medium text-white mb-3 mb-md-4 text-center text-lg-start">
                                                Reliable Services from Data to Devices..<br />
                                                Quality Service for Every Corner of Your Business.
                                            </p>
                                            <div className="text-center text-lg-start">
                                                <a href="/service" className="btn btn-primary btn-lg py-2 py-md-3 px-4 px-md-5"
                                                   data-aos="zoom-in"
                                                   data-aos-delay="500">
                                                    Read More
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="hero-slide">
                        <div className="position-relative">
                            <img
                                className="img-fluid w-100 hero-image"
                                src="img/carousel-02.jpg"
                                alt="A2Z Solutions Support"
                                style={{ 
                                    height: "calc(100vh - 80px)",
                                    minHeight: "400px",
                                    maxHeight: "800px",
                                    objectFit: "cover"
                                }}
                            />
                            <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center"
                                style={{ background: "rgba(6, 3, 21, .7)" }}>
                                <div className="container">
                                    <div className="row justify-content-center justify-content-lg-start">
                                        <div className="col-12 col-lg-8 col-md-10">
                                            <h1 className="display-5 display-lg-3 text-white mb-3 text-center text-lg-start"><strong>
                                                A2Z Solutions</strong>
                                            </h1>
                                            <p className="fs-6 fs-md-5 fw-medium text-white mb-3 mb-md-4 text-center text-lg-start">
                                                From People to Processes, We Deliver..<br />
                                                Everything You Need, All in One Place.
                                            </p>
                                            <div className="text-center text-lg-start">
                                                <a href="/service" className="btn btn-primary btn-lg py-2 py-md-3 px-4 px-md-5"
                                                   data-aos="zoom-in"
                                                   data-aos-delay="500">
                                                    Read More
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="hero-slide">
                        <div className="position-relative">
                            <img
                                className="img-fluid w-100 hero-image"
                                src="img/carousel-03.jpg"
                                alt="A2Z Solutions Business Support"
                                style={{ 
                                    height: "calc(100vh - 80px)",
                                    minHeight: "400px",
                                    maxHeight: "800px",
                                    objectFit: "cover"
                                }}
                            />
                            <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center"
                                style={{ background: "rgba(6, 3, 21, .7)" }}>
                                <div className="container">
                                    <div className="row justify-content-center justify-content-lg-start">
                                        <div className="col-12 col-lg-8 col-md-10">
                                            <h1 className="display-5 display-lg-3 text-white mb-3 text-center text-lg-start"><strong>
                                                A2Z Solutions</strong>
                                            </h1>
                                            <p className="fs-6 fs-md-5 fw-medium text-white mb-3 mb-md-4 text-center text-lg-start">
                                                Total Support for Every Business Need..<br />
                                                Excellence in Billing, Training & Workforce Services.
                                            </p>
                                            <div className="text-center text-lg-start">
                                                <a href="/service" className="btn btn-primary btn-lg py-2 py-md-3 px-4 px-md-5"
                                                   data-aos="zoom-in"
                                                   data-aos-delay="500">
                                                    Read More
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Slider>
            </div>

            {/* About Section */}
            <div className="container-fluid overflow-hidden py-4 py-md-5 px-lg-0 mt-0">
                <div className="container about py-4 py-md-5 px-lg-0">
                    <div className="row g-4 g-lg-5 mx-lg-0">
                        <div className="col-lg-6 ps-lg-0 order-2 order-lg-1">
                            <div
                                className="position-relative h-100 about-image-container"
                                data-aos="zoom-in"
                                data-aos-delay="200"
                            >
                                <img
                                    className="position-absolute img-fluid w-100 h-100 rounded"
                                    src="img/home-1.png"
                                    style={{ 
                                        objectFit: "cover",
                                        height: "100%",
                                        minHeight: "300px"
                                    }}
                                    alt="A2Z Solutions team working on client projects"
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 about-text order-1 order-lg-2">
                            <h6
                                className="text-secondary text-uppercase mb-3"
                                data-aos="fade-up"
                                data-aos-delay="100"
                            >
                                About Us
                            </h6>
                            <h1
                                className="mb-4"
                                data-aos="fade-up"
                                data-aos-delay="200"
                            >
                                End-to-End Business Support Under One Roof
                            </h1>
                            <p
                                className="mb-4"
                                data-aos="fade-up"
                                data-aos-delay="300"
                            >
                                A2Z Solutions is a multi-service business support partner offering
                                <b> medical billing</b>, <b> annotation & data entry</b>, <b> training services</b>,
                                <b> manpower solutions</b> and <b> computer hardware services</b>.
                                We help organizations focus on their core work while we take care of their
                                operations with accuracy, reliability and speed.
                            </p>
                            <div className="row g-3 g-md-4 mb-4">
                                <div
                                    className="col-sm-6"
                                    data-aos="fade-right"
                                    data-aos-delay="400"
                                >
                                    <div className="d-flex">
                                        <i className="fa fa-briefcase fa-2x text-primary mb-3 me-3"></i>
                                        <div>
                                            <h5 className="mb-1">Multi-Domain Expertise</h5>
                                            <p className="m-0">
                                                From healthcare billing to IT hardware, our specialists handle
                                                diverse business needs with industry-standard practices.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="col-sm-6"
                                    data-aos="fade-left"
                                    data-aos-delay="500"
                                >
                                    <div className="d-flex">
                                        <i className="fa fa-check-circle fa-2x text-primary mb-3 me-3"></i>
                                        <div>
                                            <h5 className="mb-1">Reliable, Accurate & Scalable</h5>
                                            <p className="m-0">
                                                Quality processes, trained professionals and flexible engagement
                                                models so your business can grow without limits.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <a
                                href="/service"
                                className="btn btn-primary py-2 py-md-3 px-4 px-md-5"
                                data-aos="zoom-in"
                                data-aos-delay="600"
                            >
                                Explore Our Services
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Features Section */}
            <div className="container-fluid overflow-hidden py-4 py-md-5 px-lg-0">
                <div className="container feature py-4 py-md-5 px-lg-0">
                    <div className="row g-4 g-lg-5 mx-lg-0">
                        <div className="col-lg-6 feature-text">
                            <h6
                                className="text-secondary text-uppercase mb-3"
                                data-aos="fade-down"
                                data-aos-delay="100"
                            >
                                Our Strengths
                            </h6>
                            <h1
                                className="mb-5"
                                data-aos="fade-down"
                                data-aos-delay="200"
                            >
                                Why Businesses Choose A2Z Solutions
                            </h1>

                            <div
                                className="d-flex mb-5"
                                data-aos="fade-right"
                                data-aos-delay="300"
                            >
                                <i className="fa fa-file-invoice-dollar text-primary fa-3x flex-shrink-0"></i>
                                <div className="ms-4">
                                    <h5>Accurate Medical Billing</h5>
                                    <p className="mb-0">
                                        End-to-end medical billing support with clean claim submissions,
                                        reduced denials and clear reporting for hospitals and clinics.
                                    </p>
                                </div>
                            </div>

                            <div
                                className="d-flex mb-5"
                                data-aos="fade-right"
                                data-aos-delay="400"
                            >
                                <i className="fa fa-database text-primary fa-3x flex-shrink-0"></i>
                                <div className="ms-4">
                                    <h5>Quality Annotation & Data Entry</h5>
                                    <p className="mb-0">
                                        High-precision data entry and annotation services to support
                                        analytics, AI projects and day-to-day operations.
                                    </p>
                                </div>
                            </div>

                            <div
                                className="d-flex mb-0"
                                data-aos="fade-right"
                                data-aos-delay="500"
                            >
                                <i className="fa fa-users-cog text-primary fa-3x flex-shrink-0"></i>
                                <div className="ms-4">
                                    <h5>Training & Manpower You Can Rely On</h5>
                                    <p className="mb-0">
                                        Job-ready training programs, skilled manpower and dependable
                                        computer hardware support to keep your teams productive.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 pe-lg-0">
                            <div
                                className="position-relative h-100 feature-image-container"
                                data-aos="zoom-in-left"
                                data-aos-delay="300"
                            >
                                <img
                                    className="position-absolute img-fluid w-100 h-100 rounded"
                                    src="img/feature-a2z.jpg"
                                    style={{ 
                                        objectFit: "cover",
                                        height: "100%",
                                        minHeight: "300px"
                                    }}
                                    alt="Professionals collaborating with A2Z Solutions support services"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Certificates Section - EXACTLY THE SAME, just added data-aos attributes */}
            <div className="container-fluid bg-light py-4 py-md-5">
                <div className="container py-4 py-md-5">
                    <div className="text-center">
                        <h1
                            className="display-6 mb-5"
                            data-aos="fade-up"
                            data-aos-delay="100"
                        >
                            Certificates & Compliances
                        </h1>
                    </div>

                    <div className="partner-logo-container">
                        <div className="row g-5 align-items-center justify-content-center">
                            {/* KEONICS */}
                            <div
                                className="col-lg-2 col-md-3 col-4 text-center"
                                data-aos="zoom-in"
                                data-aos-delay="200"
                            >
                                <div className="d-flex flex-column align-items-center h-100">
                                    <img
                                        src="img/keonics-partnership.png"
                                        className="img-fluid"
                                        alt="KEONICS"
                                        style={{
                                            maxHeight: "140px",
                                            width: "auto",
                                            padding: "15px"
                                        }}
                                    />
                                    <p className="mt-2 mb-0 small text-muted">Government of Karnataka Partner</p>
                                </div>
                            </div>
                            
                            {/* Veriteam Software Solutions */}
                            <div
                                className="col-lg-2 col-md-3 col-4 text-center"
                                data-aos="zoom-in"
                                data-aos-delay="300"
                            >
                                <div className="d-flex flex-column align-items-center h-100">
                                    <img
                                        src="img/Mask-Group-13.webp"
                                        className="img-fluid"
                                        alt="Veriteam Software Solutions"
                                        style={{
                                            maxHeight: "140px",
                                            width: "auto",
                                            padding: "15px"
                                        }}
                                    />
                                    <p className="mt-2 mb-0 small text-muted">Quality Management System</p>
                                </div>
                            </div>
                            
                            {/* Government of Karnataka */}
                            <div
                                className="col-lg-2 col-md-3 col-4 text-center"
                                data-aos="zoom-in"
                                data-aos-delay="400"
                            >
                                <div className="d-flex flex-column align-items-center h-100">
                                    <img
                                        src="img/Mask-Group-14.webp"
                                        className="img-fluid"
                                        alt="Government of Karnataka"
                                        style={{
                                            maxHeight: "140px",
                                            width: "auto",
                                            padding: "15px"
                                        }}
                                    />
                                    <p className="mt-2 mb-0 small text-muted">Information Security Management System</p>
                                </div>
                            </div>
                            
                            {/* Sikkim Skill University */}
                            <div
                                className="col-lg-2 col-md-3 col-4 text-center"
                                data-aos="zoom-in"
                                data-aos-delay="500"
                            >
                                <div className="d-flex flex-column align-items-center h-100">
                                    <img
                                        src="img/sikkim.jpeg"
                                        className="img-fluid"
                                        alt="Sikkim Skill University"
                                        style={{
                                            maxHeight: "140px",
                                            width: "auto",
                                            padding: "15px"
                                        }}
                                    />
                                    <p className="mt-2 mb-0 small text-muted">Academic Education Partner</p>
                                </div>
                            </div>
                            {/* HIPAA Compliant */}
                            <div
                                className="col-lg-2 col-md-3 col-4 text-center"
                                data-aos="zoom-in"
                                data-aos-delay="200"
                            >
                                <div className="d-flex flex-column align-items-center h-100">
                                    <img
                                        src="img/hipaa-logo.png"
                                        className="img-fluid"
                                        alt="HIPAA Compliant"
                                        style={{
                                            maxHeight: "140px",
                                            width: "auto",
                                            padding: "15px"
                                        }}
                                    />
                                    <p className="mt-2 mb-0 small text-muted">HIPAA Compliant</p>
                                </div>
                            </div>


                            {/* GDPR Compliant */}
                            <div
                                className="col-lg-2 col-md-3 col-4 text-center"
                                data-aos="zoom-in"
                                data-aos-delay="200"
                            >
                                <div className="d-flex flex-column align-items-center h-100">
                                    <img
                                        src="img/gdpr-logo.png"
                                        className="img-fluid"
                                        alt="GDPR Compliant"
                                        style={{
                                            maxHeight: "140px",
                                            width: "auto",
                                            padding: "15px"
                                        }}
                                    />
                                    <p className="mt-2 mb-0 small text-muted">GDPR Compliant</p>
                                </div>
                            </div>
                            {/* Training Partner */}
                            <div
                                className="col-lg-2 col-md-3 col-4 text-center"
                                data-aos="zoom-in"
                                data-aos-delay="600"
                            >
                                <div className="d-flex flex-column align-items-center h-100">
                                    <img
                                        src="img/train-partner.png"
                                        className="img-fluid"
                                        alt="Training Partner"
                                        style={{
                                            maxHeight: "140px",
                                            width: "auto",
                                            padding: "15px"
                                        }}
                                    />
                                    <p className="mt-2 mb-0 small text-muted">Academic Education Partner</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
                            


            {/* Stats Section */}
            <div className="container-fluid py-4 py-md-5 bg-primary text-white">
                <div className="container py-4 py-md-5">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-6">
                            <h1
                                className="display-6 mb-4"
                                data-aos="fade-right"
                                data-aos-delay="100"
                            >
                                As A2Z Solutions We Provide..
                            </h1>
                            <p
                                className="mb-4"
                                data-aos="fade-right"
                                data-aos-delay="200"
                            >
                                Our success is built on a foundation of trust, reliability, and consistent delivery. Here's what sets us apart:
                            </p>

                            <div className="row g-4">
                                <div
                                    className="col-sm-6"
                                    data-aos="fade-up"
                                    data-aos-delay="300"
                                >
                                    <div className="d-flex">
                                        <i className="fas fa-shield-alt fa-2x flex-shrink-0 me-3"></i>
                                        <div>
                                            <h5 className="mb-1">Data Security</h5>
                                            <p className="mb-0">Strict confidentiality protocols for all client data</p>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="col-sm-6"
                                    data-aos="fade-up"
                                    data-aos-delay="400"
                                >
                                    <div className="d-flex">
                                        <i className="fas fa-clock fa-2x flex-shrink-0 me-3"></i>
                                        <div>
                                            <h5 className="mb-1">24/7 Support</h5>
                                            <p className="mb-0">Round-the-clock assistance for critical operations</p>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="col-sm-6"
                                    data-aos="fade-up"
                                    data-aos-delay="500"
                                >
                                    <div className="d-flex">
                                        <i className="fas fa-rupee-sign fa-2x flex-shrink-0 me-3"></i>
                                        <div>
                                            <h5 className="mb-1">Cost-Effective</h5>
                                            <p className="mb-0">Competitive pricing without compromising quality</p>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="col-sm-6"
                                    data-aos="fade-up"
                                    data-aos-delay="600"
                                >
                                    <div className="d-flex">
                                        <i className="fas fa-map-marker-alt fa-2x flex-shrink-0 me-3"></i>
                                        <div>
                                            <h5 className="mb-1">Local Presence</h5>
                                            <p className="mb-0">On-ground support across Karnataka</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div
                                className="bg-white rounded p-4 text-dark"
                                data-aos="flip-up"
                                data-aos-delay="400"
                            >
                                <h4 className="mb-4">Our Impact in Numbers</h4>
                                <div className="row g-4">
                                    <div
                                        className="col-6"
                                        data-aos="zoom-in"
                                        data-aos-delay="500"
                                    >
                                        <div className="text-center">
                                            <h2 className="display-4 text-primary mb-0">
                                                <CountUp end={250} duration={2.5} suffix="+" />
                                            </h2>
                                            <p className="mb-0">Active Clients</p>
                                        </div>
                                    </div>
                                    <div
                                        className="col-6"
                                        data-aos="zoom-in"
                                        data-aos-delay="600"
                                    >
                                        <div className="text-center">
                                            <h2 className="display-4 text-primary mb-0">
                                                <CountUp end={1200} duration={3} suffix="+" />
                                            </h2>
                                            <p className="mb-0">Projects Completed</p>
                                        </div>
                                    </div>
                                    <div
                                        className="col-6"
                                        data-aos="zoom-in"
                                        data-aos-delay="700"
                                    >
                                        <div className="text-center">
                                            <h2 className="display-4 text-primary mb-0">
                                                <CountUp end={98} duration={2} suffix="%" />
                                            </h2>
                                            <p className="mb-0">Satisfaction Rate</p>
                                        </div>
                                    </div>
                                    <div
                                        className="col-6"
                                        data-aos="zoom-in"
                                        data-aos-delay="800"
                                    >
                                        <div className="text-center">
                                            <h2 className="display-4 text-primary mb-0">
                                                <CountUp end={25} duration={1.5} suffix="+" />
                                            </h2>
                                            <p className="mb-0">Team Members</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Custom Styles */}
            <style jsx>{`
                /* Hero Slider Styles */
                .hero-slider {
                    margin-top: 0 !important;
                }
                
                /* About Section Images */
                .about-image-container {
                    min-height: 350px;
                }
                
                .feature-image-container {
                    min-height: 400px;
                }
                
                /* Partner Logos with hover animation */
                .img-fluid {
                    transition: all 0.4s ease;
                    filter: grayscale(20%);
                }
                
                .img-fluid:hover {
                    transform: translateY(-10px) scale(1.05);
                    filter: grayscale(0%);
                    box-shadow: 0 10px 25px rgba(0,0,0,0.1);
                }
                
                /* Add animation to feature icons */
                .feature-text .fa-3x {
                    transition: all 0.3s ease;
                }
                
                .feature-text .d-flex:hover .fa-3x {
                    transform: scale(1.1);
                    color: #0d6efd !important;
                }
                
                /* Add animation to stats cards */
                .bg-white.rounded {
                    transition: all 0.3s ease;
                }
                
                .bg-white.rounded:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 10px 30px rgba(0,0,0,0.15);
                }
                
                /* CountUp numbers animation */
                .display-4 {
                    position: relative;
                }
                
                .display-4::after {
                    content: '';
                    position: absolute;
                    bottom: -5px;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 50px;
                    height: 3px;
                    background: #0d6efd;
                    opacity: 0;
                    transition: all 0.3s ease;
                }
                
                .text-center:hover .display-4::after {
                    opacity: 1;
                    width: 80px;
                }
                
                /* Button hover effects */
                .btn-primary {
                    transition: all 0.3s ease;
                    position: relative;
                    overflow: hidden;
                }
                
                .btn-primary:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 5px 15px rgba(13, 110, 253, 0.3);
                }
                
                /* Mobile Responsive Styles */
                @media (min-width: 768px) {
                    .about-image-container {
                        min-height: 500px;
                    }
                }
                
                @media (max-width: 767px) {
                    /* Mobile text adjustments */
                    .display-5 {
                        font-size: 2rem;
                        margin-bottom: 1rem;
                    }
                    
                    .display-6 {
                        font-size: 1.75rem;
                    }
                    
                    /* Mobile button sizing */
                    .btn-lg {
                        padding: 0.5rem 1.5rem;
                        font-size: 1rem;
                    }
                    
                    /* Mobile image containers */
                    .about-image-container {
                        min-height: 300px;
                        margin-top: 1.5rem;
                    }
                    
                    .feature-image-container {
                        min-height: 300px;
                        margin-top: 2rem;
                    }
                    
                    /* Mobile spacing */
                    .py-4 {
                        padding-top: 2rem !important;
                        padding-bottom: 2rem !important;
                    }
                    
                    .mb-5 {
                        margin-bottom: 2rem !important;
                    }
                    
                    /* Mobile slick dots */
                    .slick-dots {
                        bottom: 10px !important;
                    }
                    
                    .slick-dots li {
                        margin: 0 3px;
                    }
                    
                    .slick-dots li button:before {
                        font-size: 10px;
                        opacity: 0.5;
                    }
                    
                    .slick-dots li.slick-active button:before {
                        opacity: 1;
                    }
                }
                
                @media (max-width: 576px) {
                    .display-5 {
                        font-size: 1.75rem;
                    }
                    
                    .display-6 {
                        font-size: 1.5rem;
                    }
                    
                    .hero-image {
                        min-height: 350px !important;
                    }
                    
                    .about-image-container {
                        min-height: 250px;
                    }
                    
                    .feature-image-container {
                        min-height: 250px;
                    }
                    
                    .btn-lg {
                        padding: 0.4rem 1.2rem;
                        font-size: 0.9rem;
                    }
                }
                
                /* Fix slick slider issues */
                .slick-slider {
                    position: relative;
                    z-index: 1;
                }
                
                .slick-list {
                    overflow: hidden;
                }
                
                .slick-track {
                    display: flex;
                }
                
                .slick-slide {
                    height: auto;
                }
                
                .hero-slide {
                    outline: none;
                }
            `}</style>
        </>
    );
}

export default Home;